import React, { Fragment, useEffect, useState } from 'react';
import MyTimeSheetSc from './MyTimeStyles.sc';
import { useAuthContext } from '../../../../hooks';
import { get_timesheet_of_user_by_user_id } from '../../../../api/Timesheet/read/user/get_timesheet_of_user_by_user_id';
import { useForm } from 'react-hook-form'
import { insert_timesheet } from '../../../../api/Timesheet/create/insert_timesheet';
import { getOrgUsersProjects } from '../../../../api/project/getOrgUserProjects';
interface TimeSheetEntry {
  project_name: string;
  task_name: string;
  duration: string;
  date: string;
  comment: string;
  timesheet:[]
}

const MyTimeSheet = ({weekdata}:any) => {
  const { register, handleSubmit, watch, setValue } = useForm()
  const auth = useAuthContext();
  const [timeSheet, setTimeSheet] = useState<TimeSheetEntry[]>([]);
  const [currentWeek, setCurrentWeek] = useState<{ start: Date | null, end: Date | null }>({ start: null, end: null });

  // Helper function to get the start and end date of a week given a date
  const getWeekStartEnd = (date: Date): { start: Date, end: Date } => {
    let start = new Date(date);
    start.setDate(start.getDate() - start.getDay() + 1); // Set to Monday of the week
    let end = new Date(start);
    end.setDate(start.getDate() + 4); // Set to Friday of the week
    return { start, end };
  };

  useEffect(() => {
    // Set current week on initial load
    const { start, end } = getWeekStartEnd(new Date());
    setCurrentWeek({ start, end });
  }, []);

  useEffect(() => {
    // Fetch timesheet whenever currentWeek changes
    const fetchTimeSheet = async () => {
      if (!currentWeek.start || !currentWeek.end || !auth?.userInfo?.orgs[0]?.id || !auth?.userInfo?.orgs_user_id[0]) return;

      const res = await get_timesheet_of_user_by_user_id(
        auth.userInfo.orgs[0].id,
        auth.userInfo.orgs_user_id[0].toString(),
        currentWeek.start.toISOString().split("T")[0],
        currentWeek.end.toISOString().split("T")[0]
      );
      setTimeSheet(res);
    };

    if (currentWeek.start && currentWeek.end) {
      fetchTimeSheet();
    }
  }, [currentWeek, auth?.userInfo?.orgs, auth?.userInfo?.orgs_user_id]);

  const handleWeekClick = (direction: 'prev' | 'next') => {
    if (!currentWeek.start) return;

    let newDate = new Date(currentWeek.start);
    newDate.setDate(newDate.getDate() + (direction === 'prev' ? -7 : 7));
    const { start, end } = getWeekStartEnd(newDate);
    setCurrentWeek({ start, end });
  };
console.log(currentWeek,"see")
const watchProjectId = watch('project')
const [getProjects, SetProjects] = useState<any[]>([])

const fetchOrguserProjects = async () => {
  await getOrgUsersProjects(
    auth?.userInfo?.orgs[0]?.id,
    (auth?.userInfo?.orgs_user_id[0]).toString(),
  )
    .then((e: any) => {
      SetProjects(e)
    })
    .catch((e) => console.log(e))
}
const onSubmit = async (e: any) => {
  const res = await insert_timesheet(
    auth?.userInfo?.orgs[0]?.id,
    (auth?.userInfo?.orgs_user_id[0]).toString(),
    watchProjectId,
    {
      ...e,
    week_start_date:weekdata.startOfNextWeek,
    week_end_date:weekdata.endOfNextWeek,
    date:weekdata.startOfNextWeek
    },
  )
  console.log(res)
}
useEffect(() => {
  fetchOrguserProjects()

}, [watchProjectId])
 const handleSelectChange = (event:any) => {
    // Convert the selected value to a number and update the form state
    const value = Number(event.target.value);
    // Assuming you are using a form library like react-hook-form
    setValue('timesheet_type_id', value);
  }
  const [formEdit,setFormEdit] = useState(true)
  const [activeEntryId, setActiveEntryId] = useState<number | null>(null);
  const handleEditClick = (entryId: number) => {
    setActiveEntryId(entryId);
  };
  return (
    <MyTimeSheetSc>
      <div>
        <button onClick={() => handleWeekClick('prev')}>Previous Week</button>
        <button onClick={() => handleWeekClick('next')}>Next Week</button>
      </div>
      <div className="form_container">
    {timeSheet.map((parentData:any, parentIndex:any) => 
      parentData.timesheet.map((data:any, index:any) => (
        <Fragment key={parentIndex * timeSheet.length + index}>
          {activeEntryId === index ? (
            // Render form for the active entry
            <form onSubmit={handleSubmit(onSubmit)} >
            <div  className="form_sub">

            <div className="form_group">
              <label>Project:</label>
              <select
                {...register('project', {
                  required: {
                    value: true,
                    message: 'This is required',
                  },
                })}
                defaultValue={data.project_id}
              >
                {getProjects?.map((data: any,idx:any) => {
                  return (
                    <Fragment key={idx}>
                      <option value={data?.ProjectId}>
                        {data?.ProjectName}
                      </option>
                    </Fragment>
                  )
                })}
              </select>
            </div>
            <div className="form_group">
              <label>Task Name:</label>
              <input type="text" {...register('task_name')} defaultValue={data?.task_name} />
            </div>
            <div className="form_group">
              <label>Monday</label>
              <input type="number" min={0} {...register('monday_hours')} defaultValue={data?.monday_hours}/>
            </div>  
            <div className="form_group">
              <label>Tuesday</label>
              <input type="number" min={0} {...register('tuesday_hours')} defaultValue={data?.tuesday_hours} />
            </div>  
            <div className="form_group">
              <label>Wednesday</label>
              <input type="number" min={0} {...register('wednesday_hours')} defaultValue={data?.wednesday_hours} />
            </div>  
            <div className="form_group">
              <label>Thursday</label>
              <input type="number" min={0} {...register('thursday_hours')} defaultValue={data?.thursday_hours}/>
            </div>  
            <div className="form_group">
              <label>Friday</label>
              <input type="number"  min={0} {...register('friday_hours')} defaultValue={data?.friday_hours} />
            </div>  
         
            <div className="form_group">
              <label>Comments:</label>
              <input type="text" {...register('comment')} defaultValue={data?.comment} />
            </div>
            <div className="form_group">
              <label>Time Sheet Type:</label>
              <select {...register('timesheet_type_id')} onChange={handleSelectChange} defaultValue={data?.timesheet_id}>
                <option>Select an option</option>
                <option value={1}>Project</option>
                <option value={2}>Learning</option>
                <option value={3}>Discussion</option>
                <option value={4}>Others</option>
                <option value={5}>PTO</option>
              </select>
            </div>
            <div className="form_group_button">
              <button type="submit" className="submit-button">
                Submit
              </button>
            </div>
            </div>

          </form>
          ) : (
            <div onClick={() => handleEditClick(index)} className="timesheet-entry">
              <div className="entry-row">
                <div className="entry-label">Project:</div>
                <div className="entry-content">{data.project_name}</div>
              </div>
              <div className="entry-row">
                <div className="entry-label">Task Name:</div>
                <div className="entry-content">{data.task_name}</div>
              </div>
              <div className="entry-row">
                <div className="entry-label">Monday:</div>
                <div className="entry-content">{data.monday_hours} hr</div>
              </div>
              <div className="entry-row">
                <div className="entry-label">Tuesday:</div>
                <div className="entry-content">{data.tuesday_hours} hr</div>
              </div>
              <div className="entry-row">
                <div className="entry-label">Wednesday:</div>
                <div className="entry-content">{data.wednesday_hours} hr</div>
              </div>
              <div className="entry-row">
                <div className="entry-label">Thursday:</div>
                <div className="entry-content">{data.thursday_hours} hr</div>
              </div>
              <div className="entry-row">
                <div className="entry-label">Friday:</div>
                <div className="entry-content">{data.friday_hours} hr</div>
              </div>
              <div className="entry-row">
                <div className="entry-label">Comment:</div>
                <div className="entry-content">{data.comment}</div>
              </div>
            </div>
          )}
        </Fragment>
      ))
    )}
  </div>
    </MyTimeSheetSc>
  );
};

export default MyTimeSheet;
